<!-- 
    FORM PUBLICO PARA CRIACAO DE NOVO NEGOCIO
-->

<script>
import { apiORDSpost, apiORDS } from '../shared/api-functions'
import { SysVars } from '../main';
import Vue from 'vue';
import apiCrm from '../api/api-crm.js'

export default {
    props: {
    },
    
    components: {
    },

    data () {
        return {
            metadata: this.$store.getters.getEntities.metadata,
            leadcrm: {
                pessoanome: null,
                email: null,
                orgnome: null,
                fonenumero: null,
                publicform: true,
            },
        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {

    },

    methods: {
        handleSalvar () {
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                } else {
                    this.apiLead(this.leadcrm, null, this.callBackPost)
                }
            })
        },

        callBackPost (lead) {
            if (lead)
                this.$erpToastSuccess('Um novo lead foi criado')
            this.closeForm(lead)
        },

        closeForm () {
            this.$emit('closeform')
        }

    },

    watch: {

    },

    mounted () {
        this.$nextTick(function () {
            if (this.$refs.nome) {
               this.$refs.nome.focus()
            }
        })

    },

    created () {
    }

}

</script>

<template>
    <div class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container" style="width: 400px; max-width: 100%">
            <div class="nb-modal-header">
                <h4 class="def-title">Formulário Público</h4>
                <button type="button" class="close" @click="closeForm"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="nb-modal-scrollable-body">
                <div class="row">
                    <form-field v-model="leadcrm.pessoanome" type="text" col="12" label="Nome"
                        name="nome" :v-errors="errors" v-validate="{ required: true }"></form-field>
                    <form-field v-model="leadcrm.email" type="text" col="12" label="E-mail"
                        name="email" :v-errors="errors" v-validate="{ required: true, email: true }"></form-field>
                    <form-field v-model="leadcrm.orgnome" type="text" col="12" label="Empresa"
                        name="empresa" :v-errors="errors" v-validate="{ required: false }"></form-field>
                    <form-field v-model="leadcrm.fonenumero" type="fone" col="12" label="Telefone"
                        name="fone" :v-errors="errors" v-validate="{ required: true }"></form-field>
                </div>
            </div>
            <div class="modal-footer text-center">
                <v-button label="Enviar" :success="true" @click="handleSalvar"></v-button>
            </div>
        </div>

    </div>

</template>

<style>

</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-public-form.vue